import React, { useEffect } from "react"
import { ActivityIndicator, ScrollView, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { useConsentHooks } from "../../../Hooks/useConsentHooks"
import styles from "./styles"

const CheckConsentScreen = () => {
    const { handleFetchConsent, patientConsent, fetchingPatientConsent } = useConsentHooks()

    useEffect(() => {
        handleFetchConsent()
    }, [])

    return (
        <View style={styles.container}>
            <ScrollView
                keyboardShouldPersistTaps={"handled"}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 100 }}
            >
                <View style={styles.content}>
                    {fetchingPatientConsent ? (
                        <View style={{ flex: 1, justifyContent: "center", alignContent: "center" }}>
                            <ActivityIndicator color={baseColors.green.primary} size="large" style={{ padding: 20 }} />
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansRegular}
                                style={{ textAlign: "center" }}
                                fontSize={16}
                            >
                                Chargement des données en cours...
                            </OpenSansText>
                        </View>
                    ) : (
                        <></>
                    )}
                </View>
            </ScrollView>
        </View>
    )
}

export default CheckConsentScreen
